<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <sm-title-bar pageTitle="Today's all activity" [showBackToDashboard]="true"></sm-title-bar>
    </div>
  </div>
  <div class="col-sm-3">
  </div>
</div>
<div class="row" *ngIf="!loader && todaysBookingData.length > 0">
  <div class="col-md-6 col-sm-6 col-12 today_booking_t" *ngFor="let data  of todaysBookingData" (click)="bookingDetails(data)">
    <mat-card >
    <div class="plan-card">
      <!-- <button mat-icon-button [matMenuTriggerFor]="data.data_type == 1 ? menu2 : membersMenu" class="more-button"
        aria-label="More options" style="position: absolute; right: 15px; top: 20px;">
        <mat-icon>more_vert</mat-icon>
      </button> -->
    <mat-menu #menu2="matMenu">
        <!-- <button mat-menu-item *ngIf="((data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2) && (data.customer_hash && data.customer_hash != 'null'))" (click)="confirmBooking(data)">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2 || data.appointment_status == 7 || data.appointment_status == 9 || data.appointment_status == 5)" (click)="startProcess(data)">
      <mat-icon class="material-icons-outlined">timer</mat-icon>
      <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2 || data.appointment_status == 7 || data.appointment_status == 9 || data.appointment_status == 5)  && data.is_owner == 1  " (click)="assignJob(data)">
      <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
      <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
    </button>
    
    <button mat-menu-item *ngIf="(data.appointment_status == 3 || data.appointment_status == 5)" (click)="done(data)">
      <mat-icon class="material-icons-outlined">task_alt</mat-icon>
      <span>{{ 'business_bookings.opt_done' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(data.appointment_status == 3 || data.appointment_status == 9 || data.appointment_status == 4) && data.is_owner == 1" (click)="customiseBooking(data)">
      <mat-icon class="material-icons-outlined">tune</mat-icon>
      <span>Edit data</span>
    </button>
    <button mat-menu-item *ngIf="(data.appointment_status != 4 && data.appointment_status != 6 && data.appointment_status != 8) && data.booking_type == '2'" (click)="addEditMeetingData(data)">
      <mat-icon class="material-icons-outlined">video_chat</mat-icon>
      <span>Meeting info</span>
    </button>
    <button mat-menu-item *ngIf="(data.appointment_status == 3 || data.appointment_status == 9 || data.appointment_status == 4 || data.appointment_status == 7)  && data.is_owner == 1 " (click)="reset(data)">
      <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
      <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
    </button> -->
    <button mat-menu-item *ngIf="data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2 || data.appointment_status == 7 || data.appointment_status == 3 || data.appointment_status == 9 || data.appointment_status == 4 || data.appointment_status == 8 || data.appointment_status == 6 || data.appointment_status == 5" (click)="bookingDetails(data)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
    </button>
    <!-- <button mat-menu-item *ngIf="data.appointment_status == 4 " (click)="openInvoice(data)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="((data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2 || data.appointment_status == 5) && data.is_owner == 1 )" (click)="cancelBooking(data)">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(!data.customer_hash || data.customer_hash == 'null') && data.is_owner == 1 " (click)="deleteBooking(data)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete booking</span>
    </button> -->
        <!-- <button mat-menu-item *ngIf="(!data.customer_hash || data.customer_hash == 'null')&& data.is_owner == 1"
          (click)="deleteBooking(data)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>Delete booking</span>
        </button> -->
      </mat-menu>
      <mat-menu #membersMenu="matMenu">
        <button mat-menu-item (click)="viewDetailsForMember(data)">
       <mat-icon class="material-icons-outlined">info</mat-icon>
       <span>View details</span>
       </button>
       <button mat-menu-item (click)="changeAttendanceStatus(1,data)" *ngIf="data.appointment_status == 0 || data.appointment_status == null || data.appointment_status == 'null'">
       <mat-icon class="material-icons-outlined">check_circle</mat-icon>
       <span>mark as present</span>
       </button>
       <button mat-menu-item (click)="assignJobForMember(data)" *ngIf="data.appointment_status == 1  && data.session_status != 3 && data.is_owner == 1">
     <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
     <span>Assign job</span>
     </button>
      <button mat-menu-item (click)="operationForMember(data,2)" *ngIf="data.appointment_status == 1 && data.session_status != 3 && data.session_status != 2">
    <mat-icon class="material-icons-outlined">timer</mat-icon>
    <span>Start job</span>
    </button>
       <button mat-menu-item (click)="operationForMember(data,3)" *ngIf="data.appointment_status == 1 && data.session_status != 3">
      <mat-icon class="material-icons-outlined">task_alt</mat-icon>
      <span>Job done</span>
      </button>
       <button mat-menu-item (click)="changeAttendanceStatus(0,data)" *ngIf="data.appointment_status == null || data.appointment_status == 'null'">
       <mat-icon class="material-icons-outlined">cancel</mat-icon>
       <span>mark as absent</span>
       </button>
       <button mat-menu-item *ngIf="(data.appointment_status == 0 || data.appointment_status == 1) 
                && (data.is_owner == 1 || data.session_status != 3)"  (click)="deleteAttendance(data)">
       <mat-icon class="material-icons-outlined">cancel</mat-icon>
       <span>Delete attendance</span>
       </button>
          <!-- <button mat-menu-item *ngIf="data.appointment_status == 0 || data.appointment_status == 1" (click)="deleteAttendance(data)">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Delete attendance</span>
          </button> -->
          
      </mat-menu>
      <div class="today_list_booking">
        <div class="today_card_img" style="position: relative; flex-shrink: 0;">

          <!-- For bookings -->
          <mat-icon
          *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 1"
          [class.new-booking]="(data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2) && data.data_type == 1" [class.under-process]="(data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9)&& data.data_type == 1" [class.completed]="data.appointment_status == 4 && data.data_type == 1" [class.cancelled]="(data.appointment_status == 6 || data.appointment_status == 8)&& data.data_type == 1" [class.confirmed]="data.appointment_status == 5 && data.data_type == 1"


       



             class="status-icon"></mat-icon>
          <mat-icon
          *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 1"
          [class.new-booking]="(data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2) && data.data_type == 1" [class.under-process]="(data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9)&& data.data_type == 1" [class.completed]="data.appointment_status == 4 && data.data_type == 1" [class.cancelled]="(data.appointment_status == 6 || data.appointment_status == 8)&& data.data_type == 1" [class.confirmed]="data.appointment_status == 5 && data.data_type == 1"

          

             class="status-icon"></mat-icon>
          <!-- For queries -->
          <mat-icon
          *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 3"
          [class.new-booking]="(data.appointment_status == 1) && data.data_type == 3" [class.under-process]="(data.appointment_status == 2)&& data.data_type == 3" [class.completed]="data.appointment_status == 5 && data.data_type == 3" [class.cancelled]="(data.appointment_status == 4)&& data.data_type == 3" [class.confirmed]="data.appointment_status == 3 && data.data_type == 3"


       



             class="status-icon"></mat-icon>
          <mat-icon
          *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 3"
          [class.new-booking]="(data.appointment_status == 1) && data.data_type == 3" [class.under-process]="(data.appointment_status == 2)&& data.data_type == 3" [class.completed]="data.appointment_status == 5 && data.data_type == 3" [class.cancelled]="(data.appointment_status == 4)&& data.data_type == 3" [class.confirmed]="data.appointment_status == 3 && data.data_type == 3"

          

             class="status-icon"></mat-icon>

          <!-- For membership -->
             
          <mat-icon
          *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 2"
          [class.cancelled]="(data.appointment_status == 0 )&& data.data_type == 2"
          [class.new-booking]="(data.appointment_status == 1 && !data.session_status ) && data.data_type == 2"
          [class.under-process]="(data.appointment_status == 1 && (data.session_status ==  2 || data.session_status ==  1)) && data.data_type == 2"
          
          [class.completed]="(data.appointment_status == 1 && data.session_status ==  3) && data.data_type == 2"


       



             class="status-icon"></mat-icon>
          <mat-icon
          *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 2"
          [class.cancelled]="(data.appointment_status == 0 )&& data.data_type == 2"
          [class.new-booking]="(data.appointment_status == 1 && !data.session_status ) && data.data_type == 2"
          [class.under-process]="(data.appointment_status == 1 && (data.session_status ==  2 || data.session_status ==  1)) && data.data_type == 2"
          [class.completed]="(data.appointment_status == 1 && data.session_status ==  3) && data.data_type == 2"

          

             class="status-icon"></mat-icon>



          <div class="booking-initial" *ngIf="!data.customer_thumb_image || data.customer_thumb_image == 'null'">{{data.customer_name.slice(0,1)}}</div>
          <img class="booking-initial-img img-fluid rounded-circle" [src]="data.customer_thumb_image" alt="" *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
        </div>
        <div class="m-2 tbooking">
          <h2 class="plan-title"> {{ data.customer_name }}</h2>
          <p class="booking-number">  <span class="bookingstar"> {{data.time}}</span> <span *ngIf="data.data_type == 1 && data.appointment_no"><span style="color: #333;">,</span> #{{data.appointment_no}} </span></p>
        </div>
      </div>
      <div class="mobiler_ad">
        <p> {{data.phone}}, {{ data.bookingType }}</p>
      </div>
    
      <p class="plan-cost my-2">
        {{ data.business_name }}
      </p>
      <p class="address_ph my-2">
        {{ data.business_address | ellipsify:45
        }} 
      </p>
      <p class="address_ph my-2">
        <span class="bookingstatus" *ngIf="data.bookingStat && data.bookingStat != '---' && data.data_type != 3"><span class="label">Status: </span> {{data.bookingStat}}</span> 
        <span class="bookingstatus" *ngIf="data.bookingStat && data.bookingStat != '---' && data.data_type == 3" style="color: #333 !important;"> {{data.bookingStat}}</span> 
        <span class="label" *ngIf="data.paymentStat && data.paymentStat != '---'">, Payment: </span> <span class="value"  *ngIf="data.paymentStat && data.paymentStat != '---'">{{data.paymentStat}}</span>
      </p>
      <p class="plan-cost" *ngIf="data.data_type != 3">
        <span class="addign">Assigned to: </span><span class="addign"> {{ data.employee_name }} </span>
      </p>
    </div>

        <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
  </mat-card>
  </div>
</div>


  <!-- placeholder section start -->
  <div class="common_placeholder" *ngIf="!loader && todaysBookingData.length == 0">
      <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <div class="task_addedrt">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M456.832 32.133H415.6V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v17.133h-66.4V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v17.133h-66.4V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v17.133h-66.4V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v17.133H55.166C24.748 32.133 0 56.88 0 87.3v369.533C0 487.252 24.748 512 55.166 512h401.666C487.251 512 512 487.252 512 456.833V87.3c0-30.42-24.749-55.167-55.168-55.167zm-401.666 30H96.4v17.134c0 8.284 6.716 15 15 15s15-6.716 15-15V62.133h66.398v17.134c0 8.284 6.716 15 15 15s15-6.716 15-15V62.133h66.4v17.134c0 8.284 6.716 15 15 15s15-6.716 15-15V62.133h66.4v17.134c0 8.284 6.716 15 15 15s15-6.716 15-15V62.133h41.232c13.879 0 25.17 11.29 25.17 25.167v41.233H30V87.3c0-13.877 11.29-25.167 25.166-25.167zM456.832 482H55.166C41.29 482 30 470.71 30 456.833v-298.3h452v298.3C482 470.71 470.709 482 456.832 482z" fill="#929292" opacity="1" data-original="#000000"></path><path d="M151.566 208.867H87.299c-8.284 0-15 6.716-15 15v64.266c0 8.284 6.716 15 15 15h64.268c8.284 0 15-6.716 15-15v-64.266c-.001-8.284-6.716-15-15.001-15zm-15 64.266h-34.268v-34.266h34.268zM424.699 208.867h-64.266c-8.284 0-15 6.716-15 15v64.266c0 8.284 6.716 15 15 15h64.266c8.284 0 15-6.716 15-15v-64.266c0-8.284-6.716-15-15-15zm-15 64.266h-34.266v-34.266h34.266zM151.566 337.4H87.299c-8.284 0-15 6.716-15 15v64.266c0 8.284 6.716 15 15 15h64.268c8.284 0 15-6.716 15-15V352.4c-.001-8.284-6.716-15-15.001-15zm-15 64.266h-34.268V367.4h34.268zM424.699 337.4h-64.266c-8.284 0-15 6.716-15 15v64.266c0 8.284 6.716 15 15 15h64.266c8.284 0 15-6.716 15-15V352.4c0-8.284-6.716-15-15-15zm-15 64.266h-34.266V367.4h34.266zM288.133 337.4h-64.268c-8.284 0-15 6.716-15 15v64.266c0 8.284 6.716 15 15 15h64.268c8.284 0 15-6.716 15-15V352.4c0-8.284-6.716-15-15-15zm-15 64.266h-34.268V367.4h34.268zM279.475 222.673l-34.834 34.836-12.116-12.116c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l22.723 22.723a15 15 0 0 0 21.213 0l45.441-45.443c5.857-5.858 5.857-15.355 0-21.213-5.859-5.858-15.356-5.858-21.214 0z" fill="#929292" opacity="1" data-original="#000000"></path></g></svg>
        </div>
        <p>No todays bookings show</p>
    </div>
</div>